import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { ICustomsTask } from '../interfaces';
import { CustomsTasksMapper } from '../mappers';

export type IGetCustomsTaskByIdRepoResponse = IRepoResponse<200, ICustomsTask> | IRepoResponse<400 | 500, string>;

export type IGetCustomsTaskByIdRepo = IRepo<[number | string], IGetCustomsTaskByIdRepoResponse>;

export const GetCustomsTaskByIdRepoType = Symbol.for('GetCustomsTaskByIdRepo');

@bind(GetCustomsTaskByIdRepoType)
export class GetCustomsTaskByIdRepo implements IGetCustomsTaskByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/customs_tasks/info', { customs_task_id: id }) });

      if (result.status === 200) {
        const data: ICustomsTask = CustomsTasksMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
